var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaxCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 6.99996C13.3334 10.4978 10.4978 13.3333 7.00002 13.3333C3.50222 13.3333 0.666687 10.4978 0.666687 6.99996C0.666687 3.50216 3.50222 0.666626 7.00002 0.666626C10.4978 0.666626 13.3334 3.50216 13.3334 6.99996ZM10.3276 9.54977H8.16967L7.00306 6.2919L5.84578 9.52498H3.6567L1.81812 4.45019H3.49804L4.73413 7.90637L5.96607 4.46568H8.04005L8.7986 6.58514H8.79804L9.86048 9.54967L10.3276 9.54977ZM10.5906 8.82846L9.73656 6.59092L10.4967 4.46465H12.1818L10.5906 8.82846Z",
    fill: "#F78E1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaxCoin);
export default __webpack_public_path__ + "static/media/waxCoin.782fe976f785ae8c39815e37c40620bb.svg";
export { ForwardRef as ReactComponent };